import { usePunditUserContext } from "@circle-react/contexts";

export const useEventsFeatureFlags = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return {
    hasLimitUrlSharingEnabled:
      !!currentCommunitySettings?.limit_url_sharing_enabled,
    hasSplitRecurringEventsEnabled:
      !!currentCommunitySettings?.split_recurring_events_enabled,
  };
};
